export const THEMES = [
  { id: 'robo', label: { zh: 'Robo（真实）', en: 'Robo (Live)' } },
  { id: 'chamii', label: { zh: 'Chamii（可爱）', en: 'Chamii (Cute)' } },
  { id: 'miaoban', label: { zh: '喵伴（EAF）', en: 'Miaoban (EAF)' } },
  { id: 'raw', label: { zh: 'Raw（校准/调参）', en: 'Raw (Tuning)' } },
  { id: 'classic', label: { zh: '经典大眼', en: 'Classic Eyes' } },
  { id: 'oled', label: { zh: 'OLED 官方风', en: 'OLED (Official)' } },
  { id: 'ani', label: 'Ani‑Emo‑Eye' },
  { id: 'esp32', label: 'esp32‑eyes' },
  { id: 'uncanny', label: 'UncannyEyes' },
  { id: 'round', label: { zh: '圆屏 LCD', en: 'Round LCD' } },
]

export const OSS_PROJECTS_RAW = [
  {
    id: 'fluxgarage-roboeyes',
    label: 'FluxGarage / RoboEyes',
    repo: 'https://github.com/FluxGarage/RoboEyes',
    theme: 'robo',
    variant: '',
    tag: 'RoboEyes',
  },
  {
    id: 'nadeem9986-roboeyes-web-dashboard',
    label: 'nadeem9986 / RoboEyes-ESP32-Full-Web-Dashboard',
    repo: 'https://github.com/nadeem9986/RoboEyes-ESP32-Full-Web-Dashboard',
    theme: 'robo',
    variant: '',
    tag: 'RoboEyes Web',
  },
  {
    id: 'chamii-cute-macaron',
    label: 'Chamii / Cute Eyes (Macaron)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'macaron',
    tag: 'Macaron',
  },
  {
    id: 'chamii-cute-sparkle',
    label: 'Chamii / Cute Eyes (Sparkle)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'sparkle',
    tag: 'Sparkle',
  },
  {
    id: 'chamii-cute-sticker',
    label: 'Chamii / Cute Eyes (Sticker)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'sticker',
    tag: 'Sticker',
  },
  {
    id: 'miaoban-emote-display-eaf',
    label: 'Miaoban / EmoteDisplay (EAF)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'miaoban',
    variant: '',
    tag: 'Miaoban',
  },
  {
    id: 'miaoban-emote-display-eaf-echoear',
    label: 'Miaoban / EmoteDisplay (EAF) · EchoEar layout',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'miaoban',
    variant: 'echoear',
    tag: 'Miaoban · EchoEar',
  },
  {
    id: 'chamii-cute-jelly',
    label: 'Chamii / Cute Eyes (Jelly)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'jelly',
    tag: 'Jelly',
  },
  {
    id: 'chamii-cute-kitty',
    label: 'Chamii / Cute Eyes (Kitty)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'kitty',
    tag: 'Kitty',
  },
  {
    id: 'chamii-cute-boba',
    label: 'Chamii / Cute Eyes (Boba)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'boba',
    tag: 'Boba',
  },
  {
    id: 'chamii-cute-rainbow',
    label: 'Chamii / Cute Eyes (Rainbow)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'rainbow',
    tag: 'Rainbow',
  },
  {
    id: 'chamii-cute-choco',
    label: 'Chamii / Cute Eyes (Choco)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'choco',
    tag: 'Choco',
  },
  {
    id: 'chamii-cute-mochi',
    label: 'Chamii / Cute Eyes (Mochi)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'mochi',
    tag: 'Mochi',
  },
  {
    id: 'chamii-cute-neon',
    label: 'Chamii / Cute Eyes (Neon)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'neon',
    tag: 'Neon',
  },
  {
    id: 'chamii-cute-dreamy',
    label: 'Chamii / Cute Eyes (Dreamy)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'dreamy',
    tag: 'Dreamy',
  },
  {
    id: 'chamii-cute-pixel',
    label: 'Chamii / Cute Eyes (Pixel)',
    repo: 'https://github.com/Chamii-AI/chamii-main',
    theme: 'chamii',
    variant: 'pixel',
    tag: 'Pixel',
  },
  {
    id: 'asutoshpati-ani-emo-eye',
    label: 'AsutoshPati / Ani‑Emo‑Eye',
    repo: 'https://github.com/AsutoshPati/Ani-Emo-Eye',
    theme: 'ani',
    variant: '',
    tag: 'Ani‑Emo',
  },
  {
    id: 'playfultechnology-esp32-eyes',
    label: 'playfultechnology / esp32‑eyes',
    repo: 'https://github.com/playfultechnology/esp32-eyes',
    theme: 'esp32',
    variant: '',
    tag: 'esp32‑eyes',
  },
  {
    id: 'devonav-blinking-eyes-tft',
    label: 'Devonav / BlinkingEyesTFT',
    repo: 'https://github.com/Devonav/BlinkingEyesTFT',
    theme: 'classic',
    variant: '',
    tag: 'BlinkTFT',
  },
  {
    id: 'sbouthillier-esp32-uncannyeyes',
    label: 'sbouthillier / ESP32‑UncannyEyes',
    repo: 'https://github.com/sbouthillier/ESP32-UncannyEyes',
    theme: 'uncanny',
    variant: 'esp32',
    tag: 'UE‑ESP32',
  },
  {
    id: 'adafruit-uncanny-eyes',
    label: 'adafruit / Uncanny_Eyes',
    repo: 'https://github.com/adafruit/Uncanny_Eyes',
    theme: 'uncanny',
    variant: 'adafruit',
    tag: 'Uncanny',
  },
  {
    id: 'bodmer-esp8266-uncannyeyes',
    label: 'Bodmer / ESP8266_uncannyEyes',
    repo: 'https://github.com/Bodmer/ESP8266_uncannyEyes',
    theme: 'uncanny',
    variant: 'esp8266',
    tag: 'UE‑8266',
  },
  {
    id: 'chrismiller-teensyeyes',
    label: 'chrismiller / TeensyEyes',
    repo: 'https://github.com/chrismiller/TeensyEyes',
    theme: 'uncanny',
    variant: 'teensy',
    tag: 'TeensyEyes',
  },
  {
    id: 'upiir-dual-lcd-robot-eyes',
    label: 'upiir / dual_lcd_robot_eyes',
    repo: 'https://github.com/upiir/dual_lcd_robot_eyes',
    theme: 'uncanny',
    variant: 'dual_lcd',
    tag: 'DualLCD',
  },
  {
    id: 'mystereon-ttgo-tdisplay-eyes',
    label: 'Mystereon / TTGO-TDISPLAY-EYES',
    repo: 'https://github.com/Mystereon/TTGO-TDISPLAY-EYES',
    theme: 'uncanny',
    variant: 'ttgo_tdisplay',
    tag: 'TTGO‑Eye',
  },
  {
    id: 'jujojujo2003-uncannyeyes-esp32',
    label: 'jujojujo2003 / UncannyEyesESP32',
    repo: 'https://github.com/jujojujo2003/UncannyEyesESP32',
    theme: 'uncanny',
    variant: 'esp32_redo',
    tag: 'UE‑ESP32+',
  },
  {
    id: 'dalori-uncannyeyes-halloween-skull',
    label: 'dalori / ESP32-uncanny-eyes-halloween-skull',
    repo: 'https://github.com/dalori/ESP32-uncanny-eyes-halloween-skull',
    theme: 'uncanny',
    variant: 'halloween_skull',
    tag: 'SkullEye',
  },
  {
    id: 'impressto-esp-lcd-eyes',
    label: 'impressto / esp_lcd_eyes',
    repo: 'https://github.com/impressto/esp_lcd_eyes',
    theme: 'esp32',
    variant: 'lcd',
    tag: 'esp_lcd',
  },
  {
    id: 'diyforvn-esp32-tft-espi-demo',
    label: 'diyforvn / esp32_eSpi_TFT_eyes_demo',
    repo: 'https://github.com/diyforvn/esp32_eSpi_TFT_eyes_demo',
    theme: 'esp32',
    variant: 'tft_espi',
    tag: 'TFT_eSPI',
  },
  {
    id: 'thelastoutpostworkshop-round-lcd-eyes',
    label: 'thelastoutpostworkshop / ESP32LCDRound240x240Eyes',
    repo: 'https://github.com/thelastoutpostworkshop/ESP32LCDRound240x240Eyes',
    theme: 'round',
    variant: 'round240',
    tag: 'Round240',
  },
  {
    id: 'hackffm-esp32s3-oled-eyes',
    label: 'hackffm / ESP32S3_OLED_Eyes',
    repo: 'https://github.com/hackffm/ESP32S3_OLED_Eyes',
    theme: 'oled',
    variant: 's3',
    tag: 'OLED‑S3',
  },
  {
    id: 'lenny6e-oled-eyes-esp32',
    label: 'Lenny6E / oledEyes_esp32',
    repo: 'https://github.com/Lenny6E/oledEyes_esp32',
    theme: 'oled',
    variant: 'lenny',
    tag: 'OLED‑Lenny',
  },
  {
    id: 'orji123-irisoled',
    label: 'orji123 / Irisoled',
    repo: 'https://github.com/orji123/Irisoled',
    theme: 'oled',
    variant: 'ir_basic',
    tag: 'IrisOLED',
  },
  {
    id: 'deepan27vit-expressive-eyes-arduino',
    label: 'deepan27vit / Expressive-Eyes-with-Arduino',
    repo: 'https://github.com/deepan27vit/Expressive-Eyes-with-Arduino',
    theme: 'oled',
    variant: 'iris_ring',
    tag: 'Expressive',
  },
  {
    id: 'juansan0-ojos-pro',
    label: 'juansan0 / OJOS-PRO',
    repo: 'https://github.com/juansan0/OJOS-PRO',
    theme: 'oled',
    variant: 'ojos_pro',
    tag: 'OJOS',
  },
  {
    id: 'circuit-digest-arduino-oled-eyes',
    label: 'Circuit-Digest / arduino-oled-eyes-animation-robotics',
    repo: 'https://github.com/Circuit-Digest/arduino-oled-eyes-animation-robotics',
    theme: 'oled',
    variant: 'robotics',
    tag: 'OLED‑Demo',
  },
  // More open-source references (>= 15 extra)
  {
    id: 'haxellg-robot-eyes',
    label: 'HaxellG / Robot-Eyes',
    repo: 'https://github.com/HaxellG/Robot-Eyes',
    theme: 'oled',
    variant: 'official_big',
  },
  {
    id: 'muhammednihalmp-robotic-eye',
    label: 'Muhammednihalmp / robotic-eye',
    repo: 'https://github.com/Muhammednihalmp/robotic-eye',
    theme: 'oled',
    variant: 'robot_eyes_oled',
  },
  {
    id: 'diyforvn-roboteyes-oled-esp32',
    label: 'diyforvn / robotEyes_oled_esp32',
    repo: 'https://github.com/diyforvn/robotEyes_oled_esp32',
    theme: 'oled',
    variant: 'robot_eyes_oled',
    tag: 'RobotEyes OLED',
  },
  {
    id: 'engrpakistan-esp32-oled-ir',
    label: 'engrpakistan / ESP32_oled_ir',
    repo: 'https://github.com/engrpakistan/ESP32_oled_ir',
    theme: 'oled',
    variant: 'iris_ring',
  },
  {
    id: 'czechball-dragon-eyes',
    label: 'Czechball / dragon-eyes',
    repo: 'https://github.com/Czechball/dragon-eyes',
    theme: 'oled',
    variant: 'dragon',
  },
  {
    id: 'lbernstone-eyes',
    label: 'lbernstone / eyes',
    repo: 'https://github.com/lbernstone/eyes',
    theme: 'oled',
    variant: 'soft_mono',
  },
  {
    id: 'mah8050-robotic-eyes-esp32',
    label: 'mah8050 / RoboticEyesESP32',
    repo: 'https://github.com/mah8050/RoboticEyesESP32',
    theme: 'oled',
    variant: 'official_tight',
  },
  {
    id: 'sukundev-esp32-pet-robot',
    label: 'SukunDev / ESP32-Pet-Robot',
    repo: 'https://github.com/SukunDev/ESP32-Pet-Robot',
    theme: 'oled',
    variant: 'matrix',
  },
  {
    id: 'mrohimilhadi-ssd1306-robot-eyes',
    label: 'mrohimilhadi / arduino-uno-ssd1306-robot-eyes',
    repo: 'https://github.com/mrohimilhadi/arduino-uno-ssd1306-robot-eyes',
    theme: 'oled',
    variant: 'official_tight',
  },
  {
    id: 'abishekkumar01-robotics-eyes-oled',
    label: 'Abishekkumar01 / Robotics-eyes-on-OLED-display---Ardiuno-',
    repo: 'https://github.com/Abishekkumar01/Robotics-eyes-on-OLED-display---Ardiuno-',
    theme: 'oled',
    variant: 'robotics',
  },
  {
    id: 'ai-gajendra-robo-eyes-esp32',
    label: 'AI-Gajendra / Robo_eyes_esp32',
    repo: 'https://github.com/AI-Gajendra/Robo_eyes_esp32',
    theme: 'esp32',
    variant: 'tft_espi',
  },
  {
    id: 'intellar-dual-display-esp32',
    label: 'intellar / Dual_Display_ESP32',
    repo: 'https://github.com/intellar/Dual_Display_ESP32',
    theme: 'uncanny',
    variant: 'dual_lcd',
  },
  {
    id: 'simbuddy-spookyeyes',
    label: 'SimBuddy / SpookyEyes',
    repo: 'https://github.com/SimBuddy/SpookyEyes',
    theme: 'uncanny',
    variant: 'halloween_skull',
  },
  {
    id: 'dedsec995-esp32-uncanny-eyes',
    label: 'dedsec995 / esp32_uncanny_eyes',
    repo: 'https://github.com/dedsec995/esp32_uncanny_eyes',
    theme: 'uncanny',
    variant: 'esp32_redo',
  },
  {
    id: 'dedsec995-esp32-uncanny-eyes-alt',
    label: 'dedsec995 / Esp32-uncanny-eyes',
    repo: 'https://github.com/dedsec995/Esp32-uncanny-eyes',
    theme: 'uncanny',
    variant: 'esp32_redo',
  },
  {
    id: 'brandongill8-uncannyeyes-esp32c3-supermini',
    label: 'brandongill8 / UncannyEyes_ESP32-C3_Supermini',
    repo: 'https://github.com/brandongill8/UncannyEyes_ESP32-C3_Supermini',
    theme: 'uncanny',
    variant: 'esp32_redo',
  },
  {
    id: 'jman4715-round-lcd-eyes',
    label: 'jman4715 / ESP32LCDRound240x240Eyes',
    repo: 'https://github.com/jman4715/ESP32LCDRound240x240Eyes',
    theme: 'round',
    variant: 'round240',
  },
]

export const OSS_GROUP_LABELS = {
  'robo::': 'RoboEyes',
  'miaoban::': 'Miaoban (EAF)',
  'miaoban::echoear': 'Miaoban (EchoEar)',
  'chamii::macaron': 'Macaron',
  'chamii::sparkle': 'Sparkle',
  'chamii::sticker': 'Sticker',
  'chamii::jelly': 'Jelly',
  'chamii::kitty': 'Kitty',
  'chamii::boba': 'Boba',
  'chamii::rainbow': 'Rainbow',
  'chamii::choco': 'Choco',
  'chamii::mochi': 'Mochi',
  'chamii::neon': 'Neon',
  'chamii::dreamy': 'Dreamy',
  'chamii::pixel': 'Pixel',
  'ani::': 'Ani‑Emo‑Eye',
  'esp32::': 'esp32‑eyes',
  'esp32::tft_espi': 'TFT_eSPI Eyes',
  'esp32::lcd': 'esp_lcd_eyes',
  'uncanny::esp32': 'Uncanny (ESP32)',
  'uncanny::esp32_redo': 'Uncanny (ESP32+)',
  'uncanny::esp8266': 'Uncanny (ESP8266)',
  'uncanny::teensy': 'TeensyEyes',
  'uncanny::adafruit': 'Adafruit Uncanny',
  'uncanny::dual_lcd': 'Dual LCD Eyes',
  'uncanny::ttgo_tdisplay': 'TTGO‑TDisplay Eyes',
  'uncanny::halloween_skull': 'Skull Eyes',
  'round::round240': 'Round LCD 240×240',
  'oled::ir_basic': 'OLED Iris (Basic)',
  'oled::iris': 'OLED Iris',
  'oled::iris_ring': 'OLED Iris (Ring)',
  'oled::iris_cat': 'OLED Iris (Cat)',
  'oled::iris_star': 'OLED Iris (Star)',
  'oled::ojos_pro': 'OJOS‑PRO',
  'oled::dragon': 'Dragon Eyes',
  'oled::soft_mono': 'Soft Eyes (Mono)',
  'oled::soft_thick': 'Soft Eyes (Thick)',
  'oled::s3': 'OLED‑S3',
  'oled::lenny': 'OLED‑Lenny',
  'oled::robot_eyes_oled': 'RobotEyes OLED',
  'oled::robotics': 'OLED Robotics (Pixel)',
  'oled::matrix': 'Matrix Eyes',
  'oled::official_big': 'OLED Official (Big)',
  'oled::official_tight': 'OLED Official (Tight)',
}

// Main product eyes (keep these 3 first); other Chamii variants are still available as references.
export const CHAMII_PRIMARY_VARIANTS = ['macaron', 'sparkle', 'sticker']

